import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import TaskForm from '../../components/tasks/TaskForm';
import taskService from '../../services/taskService';
import { FaArrowLeft, FaEdit, FaExclamationTriangle } from 'react-icons/fa';
import "../../styles/taskManagement.css";

const EditTaskPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTask = async () => {
      try {
        setLoading(true);
        const response = await taskService.getTaskById(id);
        setTask(response?.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching task details:', err);
        setError('Failed to load task details. Please try again later.');
        setLoading(false);
      }
    };

    fetchTask();
  }, [id]);

  const handleSubmitSuccess = () => {
    navigate(`/tasks/${id}`);
  };

  if (loading) {
    return (
      <div className="task-container">
        <div className="task-content-wrapper">
          <div className="loading-container">
            <div className="spinner"></div>
            <p className="loading-text">Loading task details...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="task-container">
        <div className="task-content-wrapper">
          <div className="error-container">
            <div className="error-content">
              <FaExclamationTriangle className="error-icon" />
              <p className="error-message">{error}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!task) {
    return (
      <div className="task-container">
        <div className="task-content-wrapper">
          <div className="empty-state-container warning">
            <div className="empty-state-content">
              <FaExclamationTriangle className="empty-state-icon warning" />
              <p className="empty-state-message warning">Task not found</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="task-container">
      <div className="task-content-wrapper">
        <div className="back-link-container">
          <Link 
            to={`/tasks/${id}`} 
            className="back-link"
          >
            <FaArrowLeft className="back-link-icon" />
            <span>Back to Task Details</span>
          </Link>
        </div>

        <div className="form-page-container">
          <div className="page-header">
            <div className="page-header-icon">
              <FaEdit />
            </div>
          </div>

          <TaskForm task={task} onSubmitSuccess={handleSubmitSuccess} />
        </div>
      </div>
    </div>
  );
};

export default EditTaskPage;
